import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { SharedModule } from '../../../shared/shared.module';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-report-lookup',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './report-lookup.component.html',
  styleUrls: ['./report-lookup.component.scss']
})
export class ReportLookupComponent implements OnInit {
  loader: boolean = false; 
  path: string = '';
  properties = { OrderNumber: 0, ReportName: '', TenantId: 'default' , ReportPath:'' };
  constructor(private config: DynamicDialogConfig) {}

  ngOnInit(): void {
    this.loader = true; 
    this.initializeComponent();
  }


  async initializeComponent(): Promise<void> {
    try {
      const authString = localStorage.getItem('auth');
      if (!authString) {
        throw new Error('Auth information is missing');
      }

      const auth = JSON.parse(authString);
      if (!auth.tenant?.tenantCode) {
        throw new Error('Tenant Code is missing');
      }

      const tenant = auth.tenant.tenantCode;

      // const base_url = new URL(window.location.href).origin;
      this.path = `${environment.apiBaseUrl}/GetReportByParaAndName/{action}`;
        //  this.path = `https://localhost:7109/api/GetReportByParaAndName/{action}`;

      this.properties = {
        OrderNumber: this.config.data.OrderNo,
        ReportName: this.config.data.ReportName,
        TenantId: tenant,
        ReportPath: this.config.data.ReportPath,
      };


      await this.fetchReportData(tenant); 
    } catch (error: any) {
      console.error(error); 
      this.loader = false; 
    }
  }

  async fetchReportData(tenant: string): Promise<void> {
    try {
      await new Promise(resolve => setTimeout(resolve, 2000)); 
      this.loader = false;

    } catch (error) {
      console.error('Error fetching report data', error);
      this.loader = false; 
    }
  }
}
